import React from "react";
import "../../styles/ShareableLinks.css";
import dashboardImage from "../../ui-assets/help/dashboard.png";
import shareImage from "../../ui-assets/help/share_icon.png";
import shareableLinksImage from "../../ui-assets/help/copy_link.png";
export default function ShareableLinks() {
    return (
        <div className="shareable-page">

            {/* Header */}
            <header className="shareable-hero">
                <div className="shareable-hero-inner">

                    <div className="shareable-badge">
                        <i className="fas fa-link" />
                        <span>EventFork Help Center</span>
                    </div>

                    <h1>How to Get Shareable Links</h1>

                    <p>
                        Follow these simple steps to get and share your EventFork
                        event links with attendees, speakers, or anyone who needs
                        access to your event.
                    </p>

                </div>
            </header>

            {/* Breadcrumb */}
            <nav className="shareable-breadcrumb" aria-label="Breadcrumb">
                <div className="shareable-breadcrumb-inner">
                    <a href="/">Home</a>

                    <i className="fas fa-chevron-right" />

                    <a href="/help">Help Center</a>

                    <i className="fas fa-chevron-right" />

                    <span aria-current="page">
                        Shareable Links
                    </span>
                </div>
            </nav>

            <main className="shareable-main">

                {/* Purpose */}
                <section className="shareable-purpose">

                    <div className="section-icon">
                        <i className="fas fa-info-circle" />
                    </div>

                    <div>
                        <span className="section-label">PURPOSE</span>

                        <h2>Get the right link for your event</h2>

                        <p>
                            This guide explains how an EventFork organizer can open
                            an event's <strong>Shareable Links</strong> window and
                            copy the required link for sharing with attendees,
                            speakers, or anyone who needs the event page.
                        </p>
                    </div>

                </section>

                {/* Quick Flow */}
                <section className="quick-flow">

                    <div className="flow-title">
                        <span>Quick process</span>
                    </div>

                    <div className="flow-steps">

                        <div className="flow-step">
                            <span className="flow-number">1</span>

                            <div className="flow-icon">
                                <i className="fas fa-home" />
                            </div>

                            <strong>Home</strong>
                        </div>

                        <i className="fas fa-arrow-right flow-arrow" />

                        <div className="flow-step">
                            <span className="flow-number">2</span>

                            <div className="flow-icon">
                                <i className="fas fa-th-large" />
                            </div>

                            <strong>Dashboard</strong>
                        </div>

                        <i className="fas fa-arrow-right flow-arrow" />

                        <div className="flow-step">
                            <span className="flow-number">3</span>

                            <div className="flow-icon">
                                <i className="fas fa-share-alt" />
                            </div>

                            <strong>Share</strong>
                        </div>

                        <i className="fas fa-arrow-right flow-arrow" />

                        <div className="flow-step">
                            <span className="flow-number">4</span>

                            <div className="flow-icon">
                                <i className="fas fa-copy" />
                            </div>

                            <strong>Copy Link</strong>
                        </div>

                    </div>

                </section>

                {/* Step 1 */}
                <section className="documentation-step">

                    <div className="step-side">
                        <div className="step-number">01</div>
                    </div>

                    <div className="step-body">

                        <span className="step-label">STEP 1</span>

                        <h2>Open the Dashboard</h2>

                        <p>
                            Start from the EventFork Home page. In the top
                            navigation bar, locate the <strong>Dashboard</strong>
                            button and click it.
                        </p>

                        <p>
                            The Dashboard contains your published and unpublished
                            events.
                        </p>

                        <div className="action-box">
                            <div className="action-icon">
                                <i className="fas fa-tachometer-alt" />
                            </div>

                            <div>
                                <strong>What to do</strong>
                                <span>
                                    Click the Dashboard button from the top navigation.
                                </span>
                            </div>
                        </div>

                        {/* STEP 1 IMAGE */}
                        <div className="screenshot-box">
                            <img
                                src={dashboardImage}
                                alt="EventFork Home page showing the Dashboard button"
                            />
                        </div>

                        <p className="figure-caption">
                            Figure 1. From the Home page, click Dashboard.
                        </p>

                    </div>

                </section>

                {/* Step 2 */}
                <section className="documentation-step">

                    <div className="step-side">
                        <div className="step-number">02</div>
                    </div>

                    <div className="step-body">

                        <span className="step-label">STEP 2</span>

                        <h2>
                            Select the Event and Open Shareable Links
                        </h2>

                        <p>
                            On the Dashboard, find the event for which you want
                            to generate or retrieve a shareable link.
                        </p>

                        <p>
                            On the event card, click the
                            <strong> Share icon </strong>
                            in the top-right corner.
                        </p>

                        <div className="action-box">

                            <div className="action-icon">
                                <i className="fas fa-share-alt" />
                            </div>

                            <div>
                                <strong>What to do</strong>

                                <span>
                                    Find your event and click the Share icon on
                                    the event card.
                                </span>
                            </div>

                        </div>

                        {/* STEP 2 IMAGE */}
                        <div className="screenshot-box">
                            <img
                                src={shareImage}
                                alt="EventFork Dashboard showing the Share icon"
                            />
                        </div>

                        <p className="figure-caption">
                            Figure 2. On the required event card, click the Share icon.
                        </p>

                    </div>

                </section>



                {/* Step 3 */}
                <section className="documentation-step">

    <div className="step-side">
        <div className="step-number">03</div>
    </div>

    <div className="step-body">

        <span className="step-label">STEP 3</span>

        <h2>Copy the Required Shareable Link</h2>

        <p>
            The <strong>Shareable Links</strong> window displays
            separate links for different purposes.
        </p>

        <p>
            Choose the link you need and click its corresponding
            <strong> Copy </strong>
            button.
        </p>

        {/* Link Preview */}
        <div className="share-links-preview">

            {/* Event Link */}
            <div className="share-link-row">

                <div className="share-link-info">

                    <div className="share-link-icon event">
                        <i className="fas fa-calendar-alt" />
                    </div>

                    <div>
                        <h3>Event Link</h3>

                        <p>
                            Share the public event page so users can
                            view the event details.
                        </p>
                    </div>

                </div>

                <button type="button">
                    <i className="fas fa-copy" />
                    <span>Copy</span>
                </button>

            </div>

            {/* Attendee Link */}
            <div className="share-link-row">

                <div className="share-link-info">

                    <div className="share-link-icon attendee">
                        <i className="fas fa-user-check" />
                    </div>

                    <div>
                        <h3>Attendee Registration Link</h3>

                        <p>
                            Share directly with attendees who need
                            to register for the event.
                        </p>
                    </div>

                </div>

                <button type="button">
                    <i className="fas fa-copy" />
                    <span>Copy</span>
                </button>

            </div>

            {/* Speaker Link */}
            <div className="share-link-row">

                <div className="share-link-info">

                    <div className="share-link-icon speaker">
                        <i className="fas fa-microphone-alt" />
                    </div>

                    <div>
                        <h3>Speaker Registration Link</h3>

                        <p>
                            Share with speakers who need to submit
                            speaker registration details.
                        </p>
                    </div>

                </div>

                <button type="button">
                    <i className="fas fa-copy" />
                    <span>Copy</span>
                </button>

            </div>

        </div>

        {/* STEP 3 IMAGE */}
        <div className="screenshot-box screenshot-share">
            <img
                src={shareableLinksImage}
                alt="EventFork Shareable Links popup showing Event Link, Attendee Registration Link, Speaker Registration Link and Copy buttons"
            />
        </div>

        <p className="figure-caption">
            Figure 3. Select the required link and click Copy.
        </p>

    </div>

</section>





                {/* Available Links */}
                <section className="available-section">

                    <div className="section-heading">

                        <span className="section-label">
                            REFERENCE
                        </span>

                        <h2>Available Shareable Links</h2>

                        <p>
                            Select the link based on what you want the recipient
                            to do.
                        </p>

                    </div>

                    <div className="link-cards">

                        <article className="link-card">

                            <div className="link-card-icon event">
                                <i className="fas fa-calendar-alt" />
                            </div>

                            <div>
                                <h3>Event Link</h3>

                                <p>
                                    Share the public event page so users can view
                                    the event details.
                                </p>
                            </div>

                        </article>

                        <article className="link-card">

                            <div className="link-card-icon attendee">
                                <i className="fas fa-user-check" />
                            </div>

                            <div>
                                <h3>Attendee Registration Link</h3>

                                <p>
                                    Share directly with attendees who need to
                                    register for the event.
                                </p>
                            </div>

                        </article>

                        <article className="link-card">

                            <div className="link-card-icon speaker">
                                <i className="fas fa-microphone-alt" />
                            </div>

                            <div>
                                <h3>Speaker Registration Link</h3>

                                <p>
                                    Share with speakers who need to submit speaker
                                    registration details.
                                </p>
                            </div>

                        </article>

                    </div>

                </section>

                {/* Important Notes */}
                <section className="important-notes">

                    <div className="notes-icon">
                        <i className="fas fa-lightbulb" />
                    </div>

                    <div>

                        <span className="section-label">
                            IMPORTANT
                        </span>

                        <h2>Important Notes</h2>

                        <ul>

                            <li>
                                Each Copy button copies only the link shown
                                in the same row.
                            </li>

                            <li>
                                If you need to share the event information,
                                use <strong>Event Link</strong>.
                            </li>

                            <li>
                                If you want people to register as attendees,
                                use <strong>Attendee Registration Link</strong>.
                            </li>

                            <li>
                                If you are inviting speakers to register,
                                use <strong>Speaker Registration Link</strong>.
                            </li>

                            <li>
                                After clicking Copy, paste the link into WhatsApp,
                                email, social media, or another communication channel.
                            </li>

                        </ul>

                    </div>

                </section>

                {/* Quick Reference */}
                <section className="quick-reference">

                    <span className="section-label">
                        QUICK REFERENCE
                    </span>

                    <div className="quick-reference-path">

                        <span>Home</span>

                        <i className="fas fa-chevron-right" />

                        <span>Dashboard</span>

                        <i className="fas fa-chevron-right" />

                        <span>Event Share icon</span>

                        <i className="fas fa-chevron-right" />

                        <span>Shareable links</span>

                        <i className="fas fa-chevron-right" />

                        <strong>Copy</strong>

                    </div>

                </section>

                {/* Back to Help */}
                <div className="back-to-help">

                    <a href="/help">
                        <i className="fas fa-arrow-left" />
                        Back to Help Center
                    </a>

                </div>

            </main>
        </div>
    );
}